export default function CtaFinalSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-red-500/20 border border-red-400/30 text-red-300 text-sm font-semibold px-5 py-2 rounded-full mb-6">
          <i className="ri-alarm-warning-line text-lg"></i>
          Atenção: Prazo de 5 Anos Para Entrar Com Ação
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
          Não deixe seus direitos expirarem
        </h2>

        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          Se você teve um problema com voo, <strong className="text-white">você tem até 5 anos para buscar indenização</strong>. Depois desse prazo, você perde o direito de receber.
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-10 border border-white/20">
          <p className="text-lg text-white/95 mb-6 leading-relaxed">
            <strong className="text-teal-400">Quanto mais cedo você agir, melhor.</strong><br />
            Documentos ficam mais fáceis de conseguir, testemunhas se lembram melhor dos fatos e o processo anda mais rápido.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 text-white/80 text-base">
            <span className="flex items-center gap-2">
              <i className="ri-check-double-line text-teal-400 text-xl"></i>
              Análise gratuita em 24h
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-double-line text-teal-400 text-xl"></i>
              Sem custo inicial
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-double-line text-teal-400 text-xl"></i>
              Só paga se ganhar
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button
            onClick={() => scrollToSection('contato')}
            className="group inline-flex items-center gap-4 bg-teal-500 hover:bg-teal-600 text-white px-12 py-6 rounded-full text-xl font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-search-line text-2xl"></i>
            Verificar Meu Direito Agora
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>

          <a
            href="https://wa.me/5528998813826?text=Ol%C3%A1%2C%20quero%20verificar%20se%20tenho%20direito%20a%20indeniza%C3%A7%C3%A3o%20por%20problema%20com%20meu%20voo.%20Pode%20me%20ajudar%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-12 py-6 rounded-full text-xl font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Falar no WhatsApp
          </a>
        </div>

        <p className="text-white/70 text-sm">
          Atendimento de segunda a sexta, das 9h às 18h • Resposta em até 24 horas
        </p>
      </div>
    </section>
  );
}
